import { useEffect, useState } from "react";

const DOT_STEPS = [".", "..", "..."];

export default function useAnimatedEllipsis(isActive, intervalMs = 450) {
    const [stepIndex, setStepIndex] = useState(0);

    useEffect(() => {
        if (!isActive) {
            setStepIndex(0);
            return undefined;
        }

        const intervalId = window.setInterval(() => {
            setStepIndex((currentIndex) => (currentIndex + 1) % DOT_STEPS.length);
        }, intervalMs);

        return () => {
            clearInterval(intervalId);
        };
    }, [intervalMs, isActive]);

    return DOT_STEPS[stepIndex];
}
